import axios from 'axios'
import API from 'src/util/api'

// Files are pushed to S3 with the shared uploadToS3 helper — the same flow
// Practice Items use — so this only registers the resulting file names.
// `files` is [{ fileName, fileSize, mimeType }]; the record stores the name.
export const saveMediaFiles = (libraryKey, files) =>
  API.post(`media/${libraryKey}`, { files })

// Soft-deletes the record. The S3 object is left alone: `media/` is a flat,
// shared folder, so the same file may also be referenced by a course, lesson
// or practice item.
export const deleteMediaItem = (libraryKey, id) =>
  API.delete(`media/${libraryKey}/${id}`)

export const bulkDeleteMediaItems = (libraryKey, ids) =>
  API.post(`media/${libraryKey}/bulk-delete`, { ids })

export const isUploadCancelled = err => axios.isCancel(err)

export const createUploadCancelSource = () => axios.CancelToken.source()
